/**
 * Exclude Engine — drop a toolbar preset into a fresh rule group.
 *
 * A plain preset is one leaf on every layer; a whole-rule preset (the cap
 * presets) brings its own layer, actions, name and date range, and may be a
 * group whose children become the leaves.
 *
 * For Media Devoted | Created By James Alexandrov
 */

import type { ExcludePreset } from '../tabs/exclude/exclude-presets';
import { ALL_LAYERS, makeGroup, type ExcludeViewGroup } from './exclude-view-model';

export function presetToGroup(preset: ExcludePreset): ExcludeViewGroup {
  const node = preset.build();
  const leaves = node.kind === 'group' ? node.children : [node];
  const stamp = Date.now();
  return {
    ...makeGroup(preset.appliesTo ?? ALL_LAYERS),
    ...(preset.name ? { name: preset.name } : {}),
    ...(preset.actions ? { actions: preset.actions } : {}),
    ...(preset.dateRange ? { dateRange: preset.dateRange } : {}),
    children: leaves
      .filter((n) => n.kind === 'condition' || n.kind === 'ranking' || n.kind === 'tag')
      .map((n, i) => ({ kind: 'leaf' as const, id: `c_${stamp}_${i}`, node: n })),
  };
}
